import useStyles from 'isomorphic-style-loader/useStyles';
import { Icon, Label, Popup } from 'semantic-ui-react';

import { EPSS_COLORS, EPSS_THRESHOLDS } from '@models/vulnerabilities.const';
import { EDGE_AWARE_POPPER_MODIFIERS } from '@utils/popup';

import s from './epss-popup.scss';

export interface EPSSPopupProps {
  score: number | null;
  percentile: number | null;
}

const toPercent = (value: number) => Math.round(value * 10000) / 100;

const getBadgeColor = (score: number | null) => {
  if (score === null) return 'grey';
  const category =
    score >= EPSS_THRESHOLDS.High
      ? 'High'
      : score >= EPSS_THRESHOLDS.Medium
        ? 'Medium'
        : 'Low';
  return EPSS_COLORS[category];
};

export const EPSSPopup = ({ score, percentile }: EPSSPopupProps) => {
  useStyles(s);

  const hasScore = score !== null;
  const scoreToDisplay = hasScore ? `${toPercent(score)}%` : null;
  const percentileToDisplay = percentile != null ? toPercent(percentile) : null;

  return (
    <Popup
      position="top center"
      wide
      trigger={
        <Label className={s.badge}>
          <Icon name="circle" color={getBadgeColor(score)} />
          {scoreToDisplay ?? 'N/A'}
        </Label>
      }
      hoverable
      className={s.popup}
      popperModifiers={EDGE_AWARE_POPPER_MODIFIERS}
    >
      <Popup.Header as="h4">
        EPSS Score: {scoreToDisplay ?? ' Not Available'}
      </Popup.Header>
      <Popup.Content>
        {hasScore ? (
          <>
            <p>
              This vulnerability has an estimated {scoreToDisplay} chance of
              being exploited in the next 30 days.
            </p>
            <h4>Percentile Ranking: {percentileToDisplay ?? 0}%</h4>
            <p>
              This vulnerability has an equal or higher chance of being
              exploited in the next 30 days than {percentileToDisplay ?? 0}% of
              other vulnerabilities.
            </p>
          </>
        ) : (
          <p>No EPSS data is available for this vulnerability.</p>
        )}
      </Popup.Content>
    </Popup>
  );
};
